<template>
  <div class="filter__item">
    <label class="filter__item__title">
      {{ $t('autocaller_v2.task.state.title') }}
    </label>
    <div class="filter__item__body">
      <i-select :value="value" :clearable="true" @input="input">
        <i-option value="success" :label="$t('autocaller_v2.task.state.success')" />
        <i-option value="processing" :label="$t('autocaller_v2.task.state.processing')" />
        <i-option value="pending" :label="$t('autocaller_v2.task.state.pending')" />
        <i-option value="fail" :label="$t('autocaller_v2.task.state.fail')" />
      </i-select>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      value: {
        type: [Number, String],
        default: ''
      }
    },
    methods: {
      input(val) {
        this.$emit('input', val);
      }
    }
  };
</script>
